import { render, staticRenderFns } from "./AllCustomersAccounts.vue?vue&type=template&id=e852226e&"
import script from "./AllCustomersAccounts.vue?vue&type=script&lang=js&"
export * from "./AllCustomersAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports